//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AddIcon from '~/static/add.svg?inline';
import EditIcon from '~/static/edit.svg?inline';
import DetailModal from '../wishlists/DetailModal.vue';
import ShareModal from '../common/ShareModal.vue';
import { lightenColor } from '~/util/global';

export default {
  components: {
    AddIcon,
    EditIcon,
    DetailModal,
    ShareModal,
  },
  props: {
    collection: {
      type: Object,
      required: true,
    },
  },
  async fetch() {
    await this.$store.dispatch('wishlists/getWishlistsHeaderData', this.templateSlug);
  },
  data() {
    return {
      showWishlistModal: false,
      isEdit: false,
      isDuplicate: false,
    };
  },
  computed: {
    description() {
      return this.headerData?.description;
    },
    name() {
      return this.headerData?.name;
    },
    isPublic() {
      return !!this.headerData?.is_public;
    },
    isPrivate() {
      return !this.headerData?.is_public;
    },
    templateSlug() {
      return this.collection?.template_slug;
    },
    headerData() {
      return this.$store.getters['wishlists/wishlist'] || {};
    },
    isOwner() {
      return !!this.headerData?.is_owner;
    },

    ownerUserName() {
      return this.headerData?.user_name || 'Sumo-ling';
    },

    currentUser() {
      return this.$store.state.session.user;
    },

    getShareableLink() {
      if (process.browser) {
        return `${window.location.hostname}/collections/${this.collection.slug}`;
      }
      return '';
    },

    requestErrorMessage() {
      return this.$store.getters['wishlists/errorMessage'];
    },

    isProcessing() {
      return this.$store.getters['wishlists/isProcessing'];
    },

    usernameAbreviation() {
      const userName = this.ownerUserName;
      if (userName && userName.length >= 2) {
        const names = userName.split(' ');

        if (names.length > 1) {
          const abv = names[0].slice(0, 1) + names[1].slice(0, 1);
          return abv.toUpperCase();
        }
        return userName.slice(0, 2).toUpperCase();
      }
      return 'UN';
    },
    background() {
      if (this.collection.header_background) {
        const dk = this.collection.header_background.replace('#', '');
        const lt = lightenColor(dk, 25);
        return `radial-gradient(58.66% 71.5% at 64.93% 27.87%, #${lt} 24.72%, #${dk} 100%)`;
      }

      return null;
    },
  },

  mounted() {
    // If an anonymous user is viewing the wishlist collection
    //  Ask them to sign in or signup to add to their wishlist
    if (!this.currentUser) {
      this.$toastr.i({
        msg: '<strong>Log in</strong> or <strong>sign up</strong> to add these products to your wishlist',
        timeout: 0,
        /* Secondary/Bolt #0E6EF4 -- from figma */
        style: { backgroundColor: '#0E6EF4', width: '380px' },
      });
    }
  },

  methods: {
    openEditModal() {
      this.isEdit = true;
      this.isDuplicate = false;
      this.showWishlistModal = true;
    },

    openDuplicateModal() {
      this.isEdit = false;
      this.isDuplicate = true;
      this.showWishlistModal = true;
    },
  },
};
